import { AfterViewChecked, ChangeDetectorRef, Component, ElementRef, OnInit, ViewChild } from '@angular/core';
import { FormControl, FormGroup, Validators } from '@angular/forms';
import { ActivatedRoute, Router } from '@angular/router';
import { LazyLoadEvent, MessageService } from 'primeng/api';
import { LoaiHopDongService } from '../services/loai-hop-dong.service';
import { NguoiYeuCauService } from '../services/nguoi-yeu-cau.service';
import { NhanSuService } from '../services/nhan-su.service';
import { SoCaiNycService } from '../services/so-cai-nyc.service';
import { SoCaiService } from '../services/so-cai.service';

@Component({
  selector: 'app-so-cai',
  templateUrl: './so-cai.component.html',
  styleUrls: ['./so-cai.component.css']
})
export class SoCaiComponent implements OnInit {
  id = 0;
  disabledForm = false;
  soCaiGanDayNhat: any;
  @ViewChild('fileUpload', { static: false }) fileUpload!: ElementRef;
  nguoiYeuCau_Add_Option = [
    {
      val: true,
      text: 'Bên A'
    },
    {
      val: false,
      text: 'Bên B'
    }
  ];
  chonBenThamGiaFlag: boolean;
  position = 'top';
  nguoiYeuCauFlag = false;
  addNYCFlag = false;
  nguoiYeuCau_PageSize = 10;
  nguoiYeuCau_BenA_TotalRecords = 0;
  nguoiYeuCau_BenB_TotalRecords = 0;
  nguoiYeuCau_Loading = false;
  nguoiYeuCau_BenA_Data: any[];
  nguoiYeuCau_BenB_Data: any[];
  nguoiYeuCau_PageNumber = 0;

  nguoiYeuCau_Choose_SearchValue = '';
  nguoiYeuCau_Choose_PageSize = 10;
  nguoiYeuCau_Choose_TotalRecords = 0;
  nguoiYeuCau_Choose_Loading = false;
  nguoiYeuCau_Choose_Data: []
  nguoiYeuCau_Choose_PageNumber = 0;
  nguoiYeuCau_Choose_Choosed: any[];

  addNguoiYeuCauForm: FormGroup;

  soCongChung = 0;
  infoForm: FormGroup;
  dataLoaiHopDong: [];
  dataNhanVien: [];
  loaiHopDongForm: FormGroup;
  nhanVienForm: FormGroup;
  notCongChungVien: FormGroup;
  dataNotCongChungVien: any[];
  nguoiYeuCauForm: FormGroup;
  selectedFile: File | undefined;
  nguoiYeuCauFormGroup: FormGroup;

  dsLoaiHopDong: any[];
  dsNhanVien: any[];
  dsCongChungVien: any[];

  addLoaiHDFormGroup: FormGroup;
  addLHDFlag = false;

  selectedCongChungVienValue: any | undefined;
  selectedNhanVienValue: any | undefined;
  selectedLoaiHDValue: any | undefined;
  constructor(private router: Router, private loaiHDService: LoaiHopDongService,
    private nhanVienService: NhanSuService, private nguoiYeuCauService: NguoiYeuCauService,
    private soCaiService: SoCaiService, private messageService: MessageService,
    private routerActivate: ActivatedRoute, private soCaiNycService: SoCaiNycService, private routerActivated: ActivatedRoute) {

    this.routerActivate.params.subscribe(
      val => {
        //Lay thong tin so cai duoc add gan day nhat
        this.soCaiService.getLastSoCai().subscribe((obj: any) => {
          if (obj != null) {
            this.soCaiGanDayNhat = obj;
          }
        });
        this.routerActivate.params.subscribe(params => {
          if (params['id']) {
            this.id = +params['id']; // (+) converts string 'id' to a number
            // Kiem tra quyen sua
            this.soCaiService.checkQuyenSuaSoCai(this.id).subscribe(
              (resp: any) => {
                if (resp != null && resp != undefined) {
                  if (resp.flag == 0) {
                    this.messageService.add({ severity: 'error', summary: 'Thông báo', detail: 'Bạn không có quyền sửa hồ sơ này!' });
                    this.disabledForm = true;
                    this.infoForm.disable();
                    // this.router.navigate([this.homeNav]);
                  }
                  else {// Neu co quyen sua
                    this.disabledForm = false;
                    this.infoForm.enable();
                    this.infoForm.controls.id.setValue(this.id);
                    this.soCaiService.getSoCaiById(this.id).subscribe(
                      (res: any) => {
                        if (res != undefined) {
                          console.log(res);
                          this.infoForm.controls.id.setValue(this.id);
                          this.infoForm.controls.soCongChung.setValue(res.socongchung);
                          if (res.ngaycongchung != undefined && res.ngaycongchung != '') {
                            let ngayCongChung = new Date(res.ngaycongchung);
                            //let ngayCC = ngayCongChung.getFullYear() + '-' + (ngayCongChung.getMonth() + 1) + '-' + ngayCongChung.getDate();
                            this.infoForm.controls.ngayCongChung.setValue(ngayCongChung);
                          }
                          this.infoForm.controls.idloaihopdong.setValue(res.idloaihopdong);
                          this.loaiHDService.getLHDById(res.idloaihopdong).subscribe(
                            (resHD: any) => {
                              if (resHD != undefined) {
                                let dtHD = {
                                  id: res.idloaihopdong,
                                  tenloaihopdong: resHD.tenLoaiHopDong
                                };
                                // this.dataLoaiHopDong = [];
                                // this.dataLoaiHopDong.push(dtHD);
                                this.loaiHopDongForm.controls.id.setValue(res.idloaihopdong);
                                this.loaiHopDongForm.controls.tenLoaiHopDong.setValue(resHD);
                              }
                            });
                          this.infoForm.controls.idcongchungvien.setValue(res.idcongchungvien);
                          this.nhanVienService.getNhanSuById(res.idcongchungvien).subscribe((resCCV: any) => {
                            if (resCCV != undefined) {
                              this.nhanVienForm.controls.hoVaTen.setValue(resCCV);
                            }
                          });
                          this.infoForm.controls.phicongchung.setValue(res.phicongchung);
                          this.infoForm.controls.chiphikhac.setValue(res.chiphikhac);
                          this.infoForm.controls.thongtintaisan.setValue(res.thongtintaisan);
                          if (res.idnguoithuchien != undefined && res.idnguoithuchien > 0) {
                            this.nhanVienService.getNhanSuById(res.idnguoithuchien).subscribe(
                              (resp: any) => {
                                if (resp != undefined) {
                                  this.notCongChungVien.controls.id.setValue(resp.id);
                                  this.notCongChungVien.controls.hoVaTen.setValue(resp);
                                  this.notCongChungVien.controls.laCongChungVien.setValue(resp.lacongchungvien);
                                }
                              }
                            );
                          }
                          this.infoForm.controls.canbotindung.setValue(res.canbotindung);
                          this.infoForm.controls.ghichu.setValue(res.ghichu);
                          this.soCaiNycService.getNycBySoCaiId(this.id).subscribe(
                            (resp: any) => {
                              if (resp != undefined) {
                                for (var i = 0; i < resp.length; i++) {
                                  var item = {
                                    id: resp[i].idNYC,
                                    diachi: resp[i].diaChi,
                                    benthamgia: resp[i].benThamGia
                                  };
                                  if (resp[i].loaiBen) {
                                    this.nguoiYeuCau_BenA_Data.push(item);
                                  }
                                  else {
                                    this.nguoiYeuCau_BenB_Data.push(item);
                                  }
                                }
                              }
                            },
                            (error: any) => {
                              this.messageService.add({ severity: 'error', summary: 'Thông báo', detail: 'Chưa có thông tin người yêu cầu!' });
                            }
                          );

                        }
                        else {
                          this.messageService.add({ severity: 'error', summary: 'Thông báo', detail: 'Có lỗi khi lấy thông tin!' });
                        }
                      }
                    );
                  }
                }
              }
            );
          }
        });
      }
    );
    this.chonBenThamGiaFlag = false;
    this.dsLoaiHopDong = [];
    this.dsNhanVien = [];
    this.dsCongChungVien = [];
    this.loadDsLoaiHD();
    this.loadDsNhanVien();
    this.loadDsCongChungVien();
    this.nguoiYeuCauFormGroup = new FormGroup({
      id: new FormControl(0),
      benthamgia: new FormControl('', [Validators.required, Validators.minLength(4)]),
      diachi: new FormControl('', [Validators.required, Validators.minLength(4)]),
      loaiben: new FormControl(false)
    });
    this.addNguoiYeuCauForm = new FormGroup({
      searchValue: new FormControl('')
    });
    // this.nguoiYeuCauFormGroup.controls.loaiben.setValue(true);
    this.dataNotCongChungVien = [];
    this.nguoiYeuCau_Choose_Data = [];
    this.nguoiYeuCauForm = new FormGroup({
      id: new FormControl(0),
      benA: new FormControl(''),
      diaChiA: new FormControl(''),
      benB: new FormControl(''),
      diaChiB: new FormControl(''),
      searchValue: new FormControl('')
    });
    this.nguoiYeuCau_BenA_Data = [];
    this.nguoiYeuCau_BenB_Data = [];
    this.nguoiYeuCau_Choose_Choosed = [];
    this.dataLoaiHopDong = [];
    this.dataNhanVien = [];
    this.loaiHopDongForm = new FormGroup({
      id: new FormControl(0),
      tenLoaiHopDong: new FormControl('')
    });
    this.addLoaiHDFormGroup = new FormGroup({
      id: new FormControl(0),
      tenLoaiHopDong: new FormControl('', [Validators.required, Validators.minLength(4)])
    });
    this.nhanVienForm = new FormGroup({
      id: new FormControl(0),
      hoVaTen: new FormControl(''),
      laCongChungVien: new FormControl('')
    });
    this.notCongChungVien = new FormGroup({
      id: new FormControl(0),
      hoVaTen: new FormControl(''),
      laCongChungVien: new FormControl('')
    });
    this.infoForm = new FormGroup({
      id: new FormControl(0),
      soCongChung: new FormControl(0, [Validators.max(2147483647), Validators.maxLength(9)]),
      ngayCongChung: new FormControl('', [Validators.required]),
      idloaihopdong: new FormControl(0, [Validators.required, Validators.min(1)]),
      idcongchungvien: new FormControl(0, [Validators.required, Validators.min(1)]),
      phicongchung: new FormControl(0),
      chiphikhac: new FormControl(0),
      thongtintaisan: new FormControl('', [Validators.required]),
      idnguoithuchien: new FormControl(0, [Validators.required, Validators.min(1)]),
      canbotindung: new FormControl(''),
      ghichu: new FormControl('')
    });
    this.infoForm.controls.id.setValue(0);
    this.infoForm.controls.ngayCongChung.setValue(new Date());
  }


  ngOnInit(): void {

  }

  loaiHDChange(event: any) {
    console.log(event);
    if (event != undefined) {
      if (event.value.id == -1) {
        this.addLHDFlag = true;
      }
    }
  }

  loadDsLoaiHD() {
    this.loaiHDService.getAll().subscribe(
      (resp: any) => {
        if (resp != undefined) {
          this.dsLoaiHopDong = resp;
          this.dsLoaiHopDong.push({
            id: -1,
            tenloaihopdong: "Khác..."
          });
        }
        else {
          this.messageService.add({ severity: 'error', summary: 'Thông báo', detail: 'Có lỗi khi lấy thông tin!' });
        }
      },
      (error: any) => {
        this.messageService.add({ severity: 'error', summary: 'Thông báo', detail: 'Có lỗi khi lấy thông tin!' });
      }
    );
  }


  loadDsCongChungVien() {
    this.nhanVienService.getAllCongChungVien().subscribe(
      (resp: any) => {
        if (resp != undefined) {
          this.dsCongChungVien = resp;
          this.routerActivate.params.subscribe(
            val => {
              this.routerActivate.params.subscribe(params => {
                if (params['id'] == undefined || params['id'] == '' || params['id'] == null) {
                  if (this.dsCongChungVien != undefined && this.dsCongChungVien[1] != undefined)
                    this.nhanVienForm.controls.hoVaTen.setValue(this.dsCongChungVien[1]);
                }
              });
            });
        }
        else {
          this.messageService.add({ severity: 'error', summary: 'Thông báo', detail: 'Có lỗi khi lấy thông tin!' });
        }
      },
      (error: any) => {
        this.messageService.add({ severity: 'error', summary: 'Thông báo', detail: 'Có lỗi khi lấy thông tin!' });
      });
  }

  loadDsNhanVien() {
    this.nhanVienService.getAllNhanVien().subscribe(
      (resp: any) => {
        if (resp != undefined) {
          this.dsNhanVien = resp;
        }
        else {
          this.messageService.add({ severity: 'error', summary: 'Thông báo', detail: 'Có lỗi khi lấy thông tin!' });
        }
      },
      (error: any) => {
        this.messageService.add({ severity: 'error', summary: 'Thông báo', detail: 'Có lỗi khi lấy thông tin!' });
      });
  }

  showAddNYC(loaiBen: number) {
    this.nguoiYeuCauFormGroup.reset();
    if (loaiBen != undefined) {
      if (loaiBen == 1) {
        this.nguoiYeuCauFormGroup.controls.loaiben.setValue(true);
      }
      else {
        this.nguoiYeuCauFormGroup.controls.loaiben.setValue(false);
      }
    }
    else {
      this.nguoiYeuCauFormGroup.controls.loaiben.setValue(true);
    }
    this.addNYCFlag = true;
  }

  addNYC() {
    if (this.nguoiYeuCauFormGroup.valid) {
      // Add
      const dataPost = {
        benthamgia: this.nguoiYeuCauFormGroup.controls.benthamgia.value,
        diachi: this.nguoiYeuCauFormGroup.controls.diachi.value
      };
      this.nguoiYeuCauService.add(dataPost).subscribe(
        (resp: any) => {
          if (resp.id != undefined) {
            this.messageService.add({ severity: 'success', summary: 'Thông báo', detail: 'Đã thêm thành công!' });
            // this.getAllNYC();

            // Add vao bang chon san
            if (this.nguoiYeuCauFormGroup.controls.loaiben.value || this.nguoiYeuCauFormGroup.controls.loaiben.value == null) {
              this.nguoiYeuCau_BenA_Data.push(resp);
            }
            else {
              this.nguoiYeuCau_BenB_Data.push(resp);
            }
            this.nguoiYeuCauFormGroup.reset();
            this.addNYCFlag = false;
          }
          else {
            this.messageService.add({ severity: 'error', summary: 'Thông báo', detail: 'Có lỗi khi thêm!' });
          }
        }
      );
    }
    else {
      this.messageService.add({ severity: 'error', summary: 'Thông báo', detail: 'Bạn nhập thông tin chưa đầy đủ hoặc thiếu chính xác!' });
    }
  }

  saveSoCai() {
    this.infoForm.controls.idloaihopdong.setValue(this.loaiHopDongForm.controls.tenLoaiHopDong.value.id);
    this.infoForm.controls.idcongchungvien.setValue(this.nhanVienForm.controls.hoVaTen.value.id);
    this.infoForm.controls.idnguoithuchien.setValue(this.notCongChungVien.controls.hoVaTen.value.id);
    if (this.infoForm.valid) {
      const formData = new FormData();
      formData.append('Id', '0');
      formData.append('SoCongChung', this.infoForm.controls.soCongChung.value);
      let dsNYC_BenA = '';
      let dsNYC_BenB = '';
      if (this.nguoiYeuCau_BenA_Data.length != undefined && this.nguoiYeuCau_BenA_Data.length > 0) {
        for (let i = 0; i < this.nguoiYeuCau_BenA_Data.length; i++) {
          if (i == 0) {
            dsNYC_BenA = this.nguoiYeuCau_BenA_Data[i].id;
          }
          else {
            dsNYC_BenA += ',' + this.nguoiYeuCau_BenA_Data[i].id;
          }
        }
      }

      if (this.nguoiYeuCau_BenB_Data.length != undefined && this.nguoiYeuCau_BenB_Data.length > 0) {
        for (let i = 0; i < this.nguoiYeuCau_BenB_Data.length; i++) {
          if (i == 0) {
            dsNYC_BenB = this.nguoiYeuCau_BenB_Data[i].id;
          }
          else {
            dsNYC_BenB += ',' + this.nguoiYeuCau_BenB_Data[i].id;
          }
        }
      }

      formData.append('DanhSachIdNguoiYeuCauCC_BenA', dsNYC_BenA);
      formData.append('DanhSachIdNguoiYeuCauCC_BenB', dsNYC_BenB);
      let ngayCongChung = new Date(this.infoForm.controls.ngayCongChung.value);
      let ngayCC = ngayCongChung.getFullYear() + '-' + (ngayCongChung.getMonth() + 1) + '-' + ngayCongChung.getDate();
      // console.log(ngayCC);
      formData.append('NgayCongChung', ngayCC);
      formData.append('IdLoaiHopDong', this.infoForm.controls.idloaihopdong.value + '');
      formData.append('IdCongChungVien', this.infoForm.controls.idcongchungvien.value + '');
      formData.append('PhiCongChung', this.infoForm.controls.phicongchung.value + '');
      formData.append('ChiPhiKhac', this.infoForm.controls.chiphikhac.value + '');
      formData.append('ThongTinTaiSan', this.infoForm.controls.thongtintaisan.value);
      formData.append('IdNguoiThucHien', this.infoForm.controls.idnguoithuchien.value);
      formData.append('CanBoTinDung', this.infoForm.controls.canbotindung.value);
      formData.append('GhiChu', this.infoForm.controls.ghichu.value);
      if (this.selectedFile != undefined) {
        formData.append('LinkFile', this.selectedFile, this.selectedFile.name);
      }
      else {
        formData.append('LinkFile', '');
      }
      if (this.id <= 0) {// Add
        this.soCaiService.saveSoCai(formData).subscribe((res: any) => {

          if (res != undefined || res == null) {
            if (res.id != undefined) {
              this.messageService.add({ severity: 'success', summary: 'Thông báo', detail: 'Đã thêm thành công!' });
              this.clearInput();
            }
            else {
              if (res.messages != undefined || res.messages != null) {
                this.messageService.add({ severity: 'error', summary: 'Thông báo', detail: res.messages });
              }
              else {
                this.messageService.add({ severity: 'error', summary: 'Thông báo', detail: 'Có lỗi khi thêm!' });
              }

            }
          }
        },
          (error: any) => {
            this.messageService.add({ severity: 'error', summary: 'Thông báo', detail: 'Có lỗi khi thêm!' });
          });
      }
      else {// Update
        this.soCaiService.updateSoCai(this.id, formData).subscribe(
          (resp: any) => {
            if (resp == undefined || resp == null) {
              this.messageService.add({ severity: 'success', summary: 'Thông báo', detail: 'Đã cập nhật thành công!' });
              //this.router.navigate(['/home']);
            }
            else {
              if (resp.messages != undefined || resp.messages != null) {
                this.messageService.add({ severity: 'error', summary: 'Thông báo', detail: resp.messages });
              }
            }
          },
          (error: any) => {
            this.messageService.add({ severity: 'error', summary: 'Thông báo', detail: 'Có lỗi thực hiện!' });
          }
        );
      }
    }
    else {
      this.messageService.add({ severity: 'error', summary: 'Thông báo', detail: 'Bạn chưa nhập đủ thông tin!' });
    }
  }

  clearInput() {
    this.infoForm.reset();
    this.infoForm.controls.id.setValue(0);
    this.infoForm.controls.soCongChung.setValue(0);
    this.infoForm.controls.ngayCongChung.setValue(new Date());
    this.infoForm.controls.phicongchung.setValue(0);
    this.infoForm.controls.chiphikhac.setValue(0);
    this.loaiHopDongForm.reset();
    this.nhanVienForm.reset();
    this.notCongChungVien.reset();
    this.nguoiYeuCauForm.reset();
    this.dataNhanVien = [];
    this.dataLoaiHopDong = [];
    this.nguoiYeuCau_BenA_Data = [];
    this.nguoiYeuCau_BenB_Data = [];
    this.fileUpload.nativeElement.value = '';
  }

  fileChange(event: any) {
    this.selectedFile = <File>event.target.files[0];
    console.log(this.selectedFile);
  }

  // timKiemLoaiHopDong(event: any) {
  //   this.infoForm.controls.idloaihopdong.setValue(0);
  //   this.loaiHDService.findLoaiHopDong(event.query, 5, 0).subscribe(
  //     (resp: any) => {
  //       this.dataLoaiHopDong = resp;
  //     }
  //   );
  // }

  // timKiemNhanVien(event: any) {
  //   this.infoForm.controls.idcongchungvien.setValue(0);
  //   this.nhanVienService.findCongChungVien(event.query, 5, 0).subscribe(
  //     (resp: any) => {
  //       this.dataNhanVien = resp;
  //     }
  //   );
  // }

  // timKiemNotCongChungVien(event: any) {
  //   this.infoForm.controls.idnguoithuchien.setValue(0);
  //   this.nhanVienService.findNotCongChungVien(event.query, 5, 0).subscribe(
  //     (resp: any) => {
  //       this.dataNotCongChungVien = resp;
  //     }
  //   );
  // }

  // selectedNhanVien(item: any) {
  //   if (item != undefined) {
  //     this.infoForm.controls.idcongchungvien.setValue(item.id);
  //   } else {
  //     this.infoForm.controls.idcongchungvien.setValue(0);
  //   }
  // }

  // selectedNotCongChungVien(item: any) {
  //   if (item != undefined) {
  //     this.infoForm.controls.idnguoithuchien.setValue(item.id);
  //   } else {
  //     this.infoForm.controls.idnguoithuchien.setValue(0);
  //   }
  // }

  // selectedLoaiHopDong(item: any) {
  //   if (item != undefined) {
  //     this.infoForm.controls.idloaihopdong.setValue(item.id);
  //   } else {
  //     this.infoForm.controls.idloaihopdong.setValue(0);
  //   }
  // }

  showChooseNYC(flag: boolean) {
    this.chonBenThamGiaFlag = flag;
    this.getAllNYC();
    this.addNguoiYeuCauForm.controls.searchValue.setValue('');
    this.nguoiYeuCauFlag = true;
  }

  closeChooseNYC() {
    this.nguoiYeuCauFlag = false;
  }

  nguoiYeuCauNav() {
    this.router.navigate(['/nguoiyeucau']);
  }

  chooseNYC() {
    this.nguoiYeuCauFlag = false;
    if (this.chonBenThamGiaFlag) {
      if (this.nguoiYeuCau_BenA_Data.length != undefined && this.nguoiYeuCau_BenA_Data.length > 0
        && this.nguoiYeuCau_Choose_Choosed.length != undefined && this.nguoiYeuCau_Choose_Choosed.length > 0) {
        for (let i = 0; i < this.nguoiYeuCau_Choose_Choosed.length; i++) {
          let flag = false;
          for (let j = 0; j < this.nguoiYeuCau_BenA_Data.length; j++) {
            if (this.nguoiYeuCau_BenA_Data[j].id == this.nguoiYeuCau_Choose_Choosed[i].id) {
              flag = true;
            }
          }
          if (flag == false) {
            this.nguoiYeuCau_BenA_Data.push(this.nguoiYeuCau_Choose_Choosed[i]);
          }
        }
      }
      else {
        this.nguoiYeuCau_BenA_Data = this.nguoiYeuCau_Choose_Choosed;
      }
      this.nguoiYeuCau_BenA_TotalRecords = this.nguoiYeuCau_BenA_Data.length;
    }
    else {
      if (this.nguoiYeuCau_BenB_Data.length != undefined && this.nguoiYeuCau_BenB_Data.length > 0
        && this.nguoiYeuCau_Choose_Choosed.length != undefined && this.nguoiYeuCau_Choose_Choosed.length > 0) {
        for (let i = 0; i < this.nguoiYeuCau_Choose_Choosed.length; i++) {
          let flag = false;
          for (let j = 0; j < this.nguoiYeuCau_BenB_Data.length; j++) {
            if (this.nguoiYeuCau_BenB_Data[j].id == this.nguoiYeuCau_Choose_Choosed[i].id) {
              flag = true;
            }
          }
          if (flag == false) {
            this.nguoiYeuCau_BenB_Data.push(this.nguoiYeuCau_Choose_Choosed[i]);
          }
        }
      }
      else {
        this.nguoiYeuCau_BenB_Data = this.nguoiYeuCau_Choose_Choosed;
      }
      this.nguoiYeuCau_BenB_TotalRecords = this.nguoiYeuCau_BenB_Data.length;
    }
  }

  removeNYC(id: number, flagNYC: boolean) {
    if (flagNYC) {
      if (this.nguoiYeuCau_BenA_Data.length != undefined && this.nguoiYeuCau_BenA_Data.length > 0) {
        for (let i = 0; i < this.nguoiYeuCau_BenA_Data.length; i++) {
          if (this.nguoiYeuCau_BenA_Data[i].id == id) {
            this.nguoiYeuCau_BenA_Data.splice(i, 1);
          }
        }
      }
    }
    else {
      if (this.nguoiYeuCau_BenB_Data.length != undefined && this.nguoiYeuCau_BenB_Data.length > 0) {
        for (let i = 0; i < this.nguoiYeuCau_BenB_Data.length; i++) {
          if (this.nguoiYeuCau_BenB_Data[i].id == id) {
            this.nguoiYeuCau_BenB_Data.splice(i, 1);
          }
        }
      }
    }
  }

  clearChoosed() {
    this.nguoiYeuCau_Choose_Choosed = [];
  }

  getAllNYC() {
    this.nguoiYeuCau_Choose_Loading = true;
    this.nguoiYeuCau_Choose_Choosed = [];
    // Count
    this.nguoiYeuCauService.count(this.addNguoiYeuCauForm.controls.searchValue.value).subscribe(
      (resp: any) => {
        if (resp != undefined) {
          this.nguoiYeuCau_Choose_TotalRecords = resp;
          // console.log(this.totalRecords);
          // console.log(this.pageNumber);

          this.nguoiYeuCauService.findNYC(this.addNguoiYeuCauForm.controls.searchValue.value, this.nguoiYeuCau_Choose_PageSize,
            this.nguoiYeuCau_Choose_PageNumber).subscribe(
              (res: any) => {
                this.nguoiYeuCau_Choose_Data = res;
                this.nguoiYeuCau_Choose_Loading = false;
              }
            );
        }
      }
    );
  }

  getNYC(event: LazyLoadEvent) {
    this.nguoiYeuCau_Choose_Loading = true;
    this.nguoiYeuCau_Choose_Choosed = [];
    //event.rows

    if (event.rows != null) {
      this.nguoiYeuCau_Choose_PageSize = event.rows;
    }
    else {
      this.nguoiYeuCau_Choose_PageSize = 10;
    }
    this.nguoiYeuCauService.count(this.addNguoiYeuCauForm.controls.searchValue.value).subscribe(
      (resp: any) => {
        if (resp != undefined) {
          this.nguoiYeuCau_Choose_TotalRecords = resp;
          let pageCurrent = 0;
          if (event.first != null && event.first != undefined) {
            pageCurrent = event.first / this.nguoiYeuCau_Choose_PageSize;
          }
          else {
            pageCurrent = 0;
          }
          this.nguoiYeuCauService.findNYC(this.addNguoiYeuCauForm.controls.searchValue.value, this.nguoiYeuCau_Choose_PageSize, pageCurrent).subscribe(
            (res: any) => {
              this.nguoiYeuCau_Choose_Data = res;
              this.nguoiYeuCau_Choose_Loading = false;
            }
          );
        }
      }
    );
  }

  addLoaiHD() {
    if (this.addLoaiHDFormGroup.valid) {
      const dataPost = {
        tenloaihopdong: this.addLoaiHDFormGroup.controls.tenLoaiHopDong.value
      };
      this.loaiHDService.add(dataPost).subscribe(
        (respLHD: any) => {
          if (respLHD.id != undefined) {
            this.addLoaiHDFormGroup.reset();
            this.loaiHDService.getAll().subscribe(
              (resp: any) => {
                if (resp != undefined) {
                  this.dsLoaiHopDong = resp;
                  this.dsLoaiHopDong.push({
                    id: -1,
                    tenloaihopdong: "Khác..."
                  });
                  this.loaiHopDongForm.controls.tenLoaiHopDong.setValue(respLHD);
                  this.messageService.add({ severity: 'success', summary: 'Thông báo', detail: 'Đã thêm loại hợp đồng thành công!' });
                  this.addLHDFlag = false;
                }
                else {
                  this.messageService.add({ severity: 'error', summary: 'Thông báo', detail: 'Có lỗi khi lấy thông tin!' });
                }
              },
              (error: any) => {
                this.messageService.add({ severity: 'error', summary: 'Thông báo', detail: 'Có lỗi khi lấy thông tin!' });
              }
            );

          }
        }
      );
    }
    else {
      this.messageService.add({ severity: 'error', summary: 'Thông báo', detail: 'Bạn chưa nhập đủ thông tin!' });
    }
  }

  homeNav() {
    this.router.navigate(['/home']);
  }

}